module.exports = {
WEATHER_PROVIDED_BY:            'Weather data provided by OpenWeather',
OPEN_WEATHER_URL:                'https://openweathermap.org/'
}
